class Reassurance extends HTMLElement {
    constructor() {
        super();

        const swiper = new Swiper(this.querySelector('.reassurance-slider'), {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            slidesPerView: 1.6,
            spaceBetween: 30,
            mousewheel: {
                invert: false,
                forceToAxis: true,
            },

            breakpoints: {
                500: {
                    slidesPerView: 2.4,
                },
                750: {
                    slidesPerView: 3.4,
                },
                990: {
                    slidesPerView: 4,
                }
            }
        });
    }
}

customElements.define('reassu-rance', Reassurance);